import { render } from "./InstructorProfilePage.vue?vue&type=template&id=7f0b4f51&scoped=true"
import script from "./InstructorProfilePage.vue?vue&type=script&lang=js"
export * from "./InstructorProfilePage.vue?vue&type=script&lang=js"

import "./InstructorProfilePage.vue?vue&type=style&index=0&id=7f0b4f51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0b4f51"]])

export default __exports__